import { useAppActivity } from "@/contexts/AppActivityContext";
import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const HIDDEN_ROUTES = ["/mirror", "/check-in", "/onboarding", "/auth", "/welcome", "/splash", "/processing", "/focus"];
const ACTIVITY_ROUTES: Record<string, string> = {
  baby_feeding: "/baby/feeding",
  baby_sleep: "/baby/sleep",
  focus: "/focus",
  sleep: "/sleep",
  meditation: "/meditation",
  stimulation: "/baby/stimulation",
};
const fmt = (s: number) => `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

const ActivityBanner = () => {
  const { activeActivity, activitySeconds, stopActivity } = useAppActivity();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (HIDDEN_ROUTES.some(r => pathname.startsWith(r))) return null;

  return (
    <AnimatePresence>
      {activeActivity && (
        <motion.div
          initial={{ y: -48, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -48, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
          className="fixed top-0 left-0 right-0 z-[300]"
          style={{ maxWidth: "480px", margin: "0 auto", paddingTop: "env(safe-area-inset-top, 0px)" }}
        >
          <div
            className="flex items-center justify-between px-4 py-2.5"
            style={{
              background: "linear-gradient(90deg, hsl(222 38% 8%), hsl(187 72% 8%))",
              borderBottom: "1px solid hsl(187 72% 50% / 0.25)",
              backdropFilter: "blur(12px)",
            }}
          >
            <button onClick={() => navigate(ACTIVITY_ROUTES[activeActivity.type] || "/home")} className="flex items-center gap-2.5 flex-1">
              <span className="text-[15px]">{activeActivity.emoji}</span>
              <div>
                <p className="text-[11px] font-display font-semibold text-white leading-none">{activeActivity.label}</p>
                {activeActivity.meta && Object.values(activeActivity.meta)[0] && (
                  <p className="text-[9px] font-display mt-0.5" style={{ color: "hsl(187 72% 50% / 0.60)" }}>
                    {Object.values(activeActivity.meta)[0]}
                  </p>
                )}
              </div>
            </button>
            <div className="flex items-center gap-3">
              <span className="font-display text-[14px] font-bold" style={{ color: "#00e5ff" }}>{fmt(activitySeconds)}</span>
              <button onClick={() => stopActivity()} className="w-6 h-6 rounded-full flex items-center justify-center" style={{ background: "hsl(0 70% 50% / 0.15)", border: "1px solid hsl(0 70% 50% / 0.30)" }}>
                <X size={10} style={{ color: "hsl(0 70% 65%)" }} />
              </button>
            </div>
          </div>
          <motion.div className="h-[2px]" style={{ background: "linear-gradient(90deg, #00e5ff, hsl(187 72% 50% / 0.3))" }}
            animate={{ scaleX: [0, 1] }} transition={{ duration: 1, repeat: Infinity, ease: "linear" }} />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ActivityBanner;
